import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LorenAutomationPlanAllComponent } from "./components/loren-automation-plan-all/loren-automation-plan-all.component";
import { LorenAllAutomationPlansResolver } from "./resolvers/loren-all-automation-plans.resolver";
import { LOREN_ROUTES } from "../../shared/constants/loren-routes.constants";

const routes: Routes = [
  {
    path: "",
    resolve: {
      plans: LorenAllAutomationPlansResolver,
    },
    component: LorenAutomationPlanAllComponent,
  },
  {
    path: LOREN_ROUTES.DEFINE,
    resolve: {
      plans: LorenAllAutomationPlansResolver,
    },
    component: LorenAutomationPlanAllComponent,
    data: { define: true },
  },
  {
    path: `:id/${LOREN_ROUTES.EDIT}`,
    resolve: {
      plans: LorenAllAutomationPlansResolver,
    },
    component: LorenAutomationPlanAllComponent,
    data: { define: true },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LorenAutomationPlansRoutingModule {}
